/* eslint-disable no-debugger */
import React, { Fragment } from 'react';

import useClubRegistrationFacilityDetails from './UseClubRegistrationFacilityDetails';

import ClubRegistrationConstants from '../utils/ClubRegistrationConstants';

import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import Headings from '@usas/ui-web/components/headings/Headings';
import Input from '@usas/ui-web/components/inputs/Input';
import InternationalPhoneInput from '@usas/ui-web/components/inputs/InternationalPhoneInput';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const EMERGENCY_ACTION_PLAN_TITLE = 'Emergency Action Plan';
const EMERGENCY_ACTION_PLAN = 'Emergency Action Plan';
const EMERGENCY_ACTION_PLAN_TYPE = 'emergencyActionPlan';

const SAFETY_ACTION_PLAN_TITLE = 'Safety Action Plan';
const SAFETY_ACTION_PLAN = 'Safety Action Plan';
const SAFETY_ACTION_PLAN_TYPE = 'safetyActionPlan';

const FACILITY_CONTRACT_TITLE = 'Facility Contract or Facility Use Form';
const FACILITY_CONTRACT = 'Facility Contract';
const FACILITY_CONTRACT_TYPE = 'facilityContract';

const ClubRegistrationFacilityDetails = () => {
  const {
    usasClubFacilityLinksState,
    clubRegistrationState,
    clubRegistrationNavState,
    formState,
    errorState,
    fileState,
    removeFileModalState,
    onSaveClicked,
    onFormValueChanged,
    handleSubmit,
    onCancelGoToClubRegistrationFacilities,
    onUploadDocumentClicked,
    onOpenRemoveFileModalClicked,
    onRemoveFileModalCanceled,
    onDownloadUploadedFile,
    onRemoveDocumentClicked
  } = useClubRegistrationFacilityDetails();

  return (
    <LeftNav title={ClubRegistrationConstants.LEFT_NAV_TITLE} state={clubRegistrationNavState} validateBeforeRedirect={false}>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Edit Club Facility Contact Info</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        {Object.keys(errorState).length > 0 && errorState.clubFacilityEmergencyActionPlanUrl !== '' &&
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12 col-sm-6 col-md-4">
              <p>Emergency Action Plan is required.</p>
            </div>
          </div>
        }
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Facility Name"
              name="facilityName"
              value={formState.facilityName} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Address Line 1"
              name="address1"
              value={formState.address1} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Address Line 2"
              name="address2"
              value={formState.address2} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="City"
              name="city"
              value={formState.city} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="State"
              name="stateCode"
              value={formState.stateCode} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Zip Code"
              name="postalCode"
              value={formState?.postalCode} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Facility Primary Contact Name*"
              name="contactName"
              value={formState.contactName}
              error={errorState.contactName}
              message={errorState.contactName}
              onChange={(value) => { onFormValueChanged('contactName', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Facility Email*"
              name="contactEmailAddress"
              value={formState?.contactEmailAddress}
              error={errorState.contactEmailAddress}
              message={errorState.contactEmailAddress}
              onChange={(value) => { onFormValueChanged('contactEmailAddress', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <InternationalPhoneInput
              label="Facility Phone Number*"
              name="contactPhoneNumber"
              value={formState.contactPhoneNumber}
              error={errorState.contactPhoneNumber}
              message={errorState.contactPhoneNumber}
              onChange={(value) => { onFormValueChanged('contactPhoneNumber', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Name of Club Contact for Facility*"
              name="clubFacilityContactName"
              value={formState.clubFacilityContactName}
              error={errorState.clubFacilityContactName}
              message={errorState.clubFacilityContactName}
              onChange={(value) => { onFormValueChanged('clubFacilityContactName', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Email of Club Contact for Facility*"
              name="clubFacilityContactEmailAddress"
              value={formState.clubFacilityContactEmailAddress}
              error={errorState.clubFacilityContactEmailAddress}
              message={errorState.clubFacilityContactEmailAddress}
              onChange={(value) => { onFormValueChanged('clubFacilityContactEmailAddress', value) }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <InternationalPhoneInput
              label="Phone # of Club Contact for Facility*"
              name="clubFacilityContactPhoneNumber"
              value={formState.clubFacilityContactPhoneNumber}
              error={errorState.clubFacilityContactPhoneNumber}
              message={errorState.clubFacilityContactPhoneNumber}
              onChange={(value) => { onFormValueChanged('clubFacilityContactPhoneNumber', value) }} />
          </div>

          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Facility Can Host Meet?"
              name="hostMeet"
              value={formState.hostMeet === true ? "Yes" : "No"} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <YesNoSwitch
              label="Is this a training facility?"
              name="trainingFacility"
              checked={formState.trainingFacility}
              error={errorState.trainingFacility}
              message={errorState.trainingFacility}
              onChange={(value) => { onFormValueChanged('trainingFacility', value); }}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-12">
            <YesNoSwitch
              label="Include in Team Finder?"
              name="includeInTeamFinder"
              checked={formState.includeInTeamFinder}
              error={errorState.includeInTeamFinder}
              message={errorState.includeInTeamFinder}
              onChange={(value) => { onFormValueChanged('includeInTeamFinder', value); }}
            />
            <span style={{ color: '#202020', fontStyle: 'italic' }}>
              By enabling this option, your facility will appear in ‘Find a Team’. Only the facility address will be visible.
            </span>
          </div>
        </div>
        <div className="row usas-extra-top-margin" style={{ paddingLeft: 20 }}>
          <div>
            <hr></hr>
          </div>

          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <Headings.H6>{EMERGENCY_ACTION_PLAN_TITLE}</Headings.H6>
              <p style={{ color: '#202020', fontSize: 17 }}>
                Outlines emergency handling procedures and assigns roles to facility personnel.
              </p></div>
          </div>
          {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
            clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12">
                {fileState.clubFacilityEmergencyActionPlanFileUrl === '' ?
                  <Fragment>
                    <label htmlFor="eap-file-upload" className={global.FileUpload}>
                      Upload File
                    </label>
                    <input hidden id="eap-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, EMERGENCY_ACTION_PLAN)} />
                    &nbsp;(*.pdf), (*.doc), or (*.docx)
                  </Fragment>
                  :
                  <Fragment>
                    <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, EMERGENCY_ACTION_PLAN_TYPE) }}>
                      {fileState.clubFacilityEmergencyActionPlanFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                    </SecondaryButton>&nbsp;
                    {fileState.clubFacilityEmergencyActionPlanFileName.includes("Bad Request") === false &&
                      <PrimaryButton
                        type="button"
                        onClick={(e) => { onDownloadUploadedFile(e, fileState.clubFacilityEmergencyActionPlanFileUrl) }}>Download Uploaded File</PrimaryButton>
                    }
                  </Fragment>}
              </div>
            </div> :
            <Fragment >
              <div className="row usas-extra-bottom-margin" hidden={fileState.clubFacilityEmergencyActionPlanFileUrl !== ''}>
                <div className="col-xs-12">
                  <p><b>No Uploaded File</b> </p>
                </div>
              </div>
            </Fragment>}
          <div className="row usas-extra-bottom-margin" hidden={fileState.clubFacilityEmergencyActionPlanFileUrl === ''}>
            <div className="col-xs-12">
              {fileState.clubFacilityEmergencyActionPlanFileName.includes("Bad Request")
                ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
                : <p><b>Uploaded File Name:</b> {fileState.clubFacilityEmergencyActionPlanFileName}</p>
              }
            </div>
          </div>
          <div>
            <hr></hr>
          </div>
        </div>
        <div className="row usas-extra-top-margin" style={{ paddingLeft: 20 }}>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H6>{SAFETY_ACTION_PLAN_TITLE}</Headings.H6>
            </div>
            <p style={{ color: '#202020', fontSize: 17, paddingLeft: 15, paddingTop: 20 }}>
              Specifies how club personnel will integrate into the facility’s EAP.
            </p>
          </div>
          {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
            clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12">
                {fileState.clubFacilitySafetyActionPlanFileUrl === '' ?
                  <Fragment>
                    <label htmlFor="sap-file-upload" className={global.FileUpload}>
                      Upload File
                    </label>
                    <input hidden id="sap-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, SAFETY_ACTION_PLAN)} />
                    &nbsp;(*.pdf), (*.doc), or (*.docx)
                  </Fragment>
                  :
                  <Fragment>
                    <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, SAFETY_ACTION_PLAN_TYPE) }}>
                      {fileState.clubFacilitySafetyActionPlanFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                    </SecondaryButton>&nbsp;
                    {fileState.clubFacilitySafetyActionPlanFileName.includes("Bad Request") === false &&
                      <PrimaryButton
                        type="button"
                        onClick={(e) => { onDownloadUploadedFile(e, fileState.clubFacilitySafetyActionPlanFileUrl) }}>Download Uploaded File</PrimaryButton>
                    }
                  </Fragment>}
              </div>
            </div> :
            <Fragment >
              <div className="row usas-extra-bottom-margin" hidden={fileState.clubFacilitySafetyActionPlanFileUrl !== ''}>
                <div className="col-xs-12">
                  <p><b>No Uploaded File</b> </p>
                </div>
              </div>
            </Fragment>}
          <div className="row usas-extra-bottom-margin" hidden={fileState.clubFacilitySafetyActionPlanFileUrl === ''}>
            <div className="col-xs-12">
              {fileState.clubFacilitySafetyActionPlanFileName.includes("Bad Request")
                ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
                : <p><b>Uploaded File Name:</b> {fileState.clubFacilitySafetyActionPlanFileName}</p>
              }
            </div>
          </div>
          <div>
            <hr></hr>
          </div>
        </div>
        <div className="row usas-extra-top-margin" style={{ paddingLeft: 20 }}>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H6>{FACILITY_CONTRACT_TITLE}</Headings.H6>
            </div>
            <p style={{ color: '#202020', fontSize: 17, paddingLeft: 15, paddingTop: 20 }}>
              The Facility Contract or Facility Use Form is to certify that your club has secured water time at the facility.
            </p>
          </div>
          {clubRegistrationState.objData.status === ClubRegistrationConstants.IN_PROGRESS_STATUS ||
            clubRegistrationState.objData.status === ClubRegistrationConstants.RENEWING_STATUS ?
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12">
                {fileState.clubFacilityContractFileUrl === '' ?
                  <Fragment>
                    <label htmlFor="sap-file-upload" className={global.FileUpload}>
                      Upload File
                    </label>
                    <input hidden id="sap-file-upload" type="file" onChange={(e) => onUploadDocumentClicked(e, FACILITY_CONTRACT)} />
                    &nbsp;(*.pdf), (*.doc), or (*.docx)
                  </Fragment>
                  :
                  <Fragment>
                    <SecondaryButton onClick={(e) => { onOpenRemoveFileModalClicked(e, FACILITY_CONTRACT_TYPE) }}>
                      {fileState.clubFacilityContractFileName.includes("Bad Request") ? "Clear Invalid" : "Remove Uploaded"} File
                    </SecondaryButton>&nbsp;
                    {fileState.clubFacilityContractFileName.includes("Bad Request") === false &&
                      <PrimaryButton
                        type="button"
                        onClick={(e) => { onDownloadUploadedFile(e, fileState.clubFacilityContractFileUrl) }}>Download Uploaded File</PrimaryButton>
                    }
                  </Fragment>}
              </div>
            </div> :
            <Fragment >
              <div className="row usas-extra-bottom-margin" hidden={fileState.clubFacilityContractFileUrl !== ''}>
                <div className="col-xs-12">
                  <p><b>No Uploaded File</b> </p>
                </div>
              </div>
            </Fragment>}
          <div className="row usas-extra-bottom-margin" hidden={fileState.clubFacilityContractFileUrl === ''}>
            <div className="col-xs-12">
              {fileState.clubFacilityContractFileName.includes("Bad Request")
                ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
                : <p><b>Uploaded File Name:</b> {fileState.clubFacilityContractFileName}</p>
              }
            </div>
          </div>
          <div>
            <hr></hr>
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onSaveClicked}>Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelGoToClubRegistrationFacilities}>Back</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={usasClubFacilityLinksState.isArrayLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={usasClubFacilityLinksState.isSaving} />
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={removeFileModalState.modalTitle}
        displayPopUp={removeFileModalState.displayPopUp}
        onModalCanceled={onRemoveFileModalCanceled}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>File Type:</b> {removeFileModalState.fileType}</p>
            {removeFileModalState.fileName.includes("Bad Request")
              ? <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
              : <p><b>Uploaded File Name:</b> {removeFileModalState.fileName}</p>
            }
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <PrimaryButton type="button" onClick={(e) => onRemoveDocumentClicked(e, removeFileModalState.fileType)}>Yes, Remove</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onRemoveFileModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </LeftNav>
  );
};

export default ClubRegistrationFacilityDetails;